/**
 * Consent management for analytics
 *
 * This module handles user consent for analytics tracking
 * and provides utilities to check consent status
 */

/**
 * Check if user has granted analytics consent
 * Replace this with your actual consent management logic
 */
export function hasAnalyticsConsent(): boolean {
	// Replace with your consent management logic
	// This could be a cookie, localStorage, or external consent manager
	if (typeof window === 'undefined') return false

	return localStorage.getItem('analytics_consent') === 'granted'
}

/**
 * True only when the user has actively opted out. Distinct from
 * `hasAnalyticsConsent`, which is false until someone opts in — that stricter
 * reading is the one to switch to if a consent banner ships.
 */
export function hasRevokedAnalyticsConsent(): boolean {
	if (typeof window === 'undefined') return false

	try {
		return localStorage.getItem('analytics_consent') === 'denied'
	} catch {
		return false
	}
}

/**
 * Grant analytics consent
 */
export function grantAnalyticsConsent(): void {
	if (typeof window === 'undefined') return

	localStorage.setItem('analytics_consent', 'granted')
}

/**
 * Revoke analytics consent
 */
export function revokeAnalyticsConsent(): void {
	if (typeof window === 'undefined') return

	localStorage.setItem('analytics_consent', 'denied')
}

/**
 * Check consent from server-side request
 * Used when reading PostHog cookies in server actions
 */
export function hasServerAnalyticsConsent(request: Request): boolean {
	const consentCookie = request.headers
		.get('cookie')
		?.includes('analytics_consent=granted')

	return Boolean(consentCookie)
}
